import moment from "moment/moment";
import isEmpty from "lodash/isEmpty";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {Outlet, useNavigate} from "react-router-dom";
import React, {useEffect, useRef, useState} from 'react';
import Wrapper from "../../components/Wrapper";
import ElementStatistics from "./ElementStatistics";
import StatisticFilter from "../../components/StatisticFilter";
import CustomDatePicker from "../../components/CustomDatePicker";
import {
    useLazyGetStatisticsQuery,
    useLazyGetStatisticsPageQuery,
} from "../../store/service/adbService";
import {setLoader} from "../../store/slice/dashboard";
import {setFilteredData, setStatisticData} from "../../store/slice/statistic";
import './index.scss';
import DashboardDetailModal from "./DashboardDetailModal";
import ProjectMonitoringManagement from "../ProjectsMonitoringManagement/ProjectMonitoringManagement";
import ProcurementManagementDashboard from "../ProcurementManagementDashboard/ProcurementManagementDashboard";

const ManagementDashboard = () =>{
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const filteredData = useSelector((state) => state?.statisticReducer?.filteredData);
  const [statisticsPage,setStatisticsPage] = useState({});
  const [viewModel, setViewModel] = useState(true)
  const[
    getStatisticsPage,
    {
      data: statisticsPageData,
      isLoading: statisticsPageDataLoading,
    }]
      = useLazyGetStatisticsPageQuery();

  const [getStatistics, {
    isLoading: statisticsDataIsLoading,
    isFetching: statisticsDataIsFetching,
  }] = useLazyGetStatisticsQuery();

  useEffect(() => {
    if (!localStorage.getItem("user_token")) {
      return  navigate("/login");
    }
    getStatisticsPage();
  }, []);

  useEffect(() => {
    statisticsPageDataLoading || statisticsDataIsFetching || statisticsDataIsLoading ? dispatch(setLoader(true)) : dispatch(setLoader(false))
  }, [ statisticsDataIsLoading, statisticsDataIsFetching, statisticsPageDataLoading ]);

  useEffect(() => {
    setStatisticsPage(statisticsPageData?.data?.translations);
  }, [statisticsPageData]);

    return(
        <Wrapper classname="statistics">
            <div className="statistics__header">
                <h1>{statisticsPage?.['index.index.headers.management_dashboard']}</h1>
              {/*<div className="statistics__sub-nav">*/}
                {/*<div className={`sub-nav__item ${viewModel ? "active" : ""}`} onClick={() => setViewModel(true)}>{statisticsPage?.["procurement_milestone_monitoring.index.headers.procurement_milestone_monitoring"]}</div>*/}
                {/*<div className={`sub-nav__item ${!viewModel ? "active" : ""}`} onClick={() => setViewModel(false)}>{statisticsPage?.["index.index.headers.projects"]}</div>*/}
              {/*</div>*/}
            </div>
          {/*{viewModel && <ProcurementManagementDashboard statisticsPage={statisticsPage} />}*/}
           <ProjectMonitoringManagement statisticsPage={statisticsPage} ></ProjectMonitoringManagement>
        </Wrapper>
    )
}

export default ManagementDashboard;
